import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
// import github from '../img/github-icon.svg'

const Face = styled.h1`
    font-size: 4rem;
    vertical-align: bottom;
`;

const Hearts = styled.span`
    font-size: 2rem;
    vertical-align: top;
    color: coral;
`;

const Header = styled.div`
    font-family: sans-serif;
`;

const Menu = styled.div`
    .hov {
        color: white;
        margin-right: 0.5rem;
    }
    
    .navbar-item:hover {
        color: coral;
        .hov {
            color: coral;
        }
    }
`;

const Navbar = () => (
  <nav className="navbar is-transparent">
    <div className="container">
      <Header className="navbar-brand">
        <Link to="/" className="navbar-item">
            <Hearts>♥♥</Hearts>
            <Face style={{ color: 'cornflowerblue' }}>⁽ ¨̮⁾</Face>
            <Face style={{ color: 'mediumseagreen' }}>⁽¨̮ ⁾</Face>
            <Hearts>♥♥</Hearts>
        </Link>
      </Header>
      {/*<div className="navbar-start">*/}
      {/*</div>*/}
      <Menu className="navbar-start">
          <Link className="navbar-item" to="/bees">
              <span className={"hov"}>►</span> bees
          </Link>
          <Link className="navbar-item" to={"/tags"}>
              <span className={"hov"}>►</span> tags
          </Link>
      </Menu>
    </div>
  </nav>
)

export default Navbar
